(function () {
  const $ = s => document.querySelector(s), $$ = s => [...document.querySelectorAll(s)];
  const CFG = window.vibCfg || {};
  const fmt = n => '$' + Number(n).toFixed(2);
  const set = (sel, v) => { const e = $(sel); if (e) e.textContent = v; };
  const form = $('#vib-product-form');
  const idInput = $('#vibVariantId');
  const toast = msg => { const t = $('#toast'); if (!t) return; t.textContent = msg; t.classList.add('show'); setTimeout(() => t.classList.remove('show'), 2200); };

  // ---------- gallery ----------
  const main = $('#gMain');
  const tb = $$('#thumbs button');
  function showMedia(el) {
    const cur = main && main.querySelector('#gImg');
    if (cur) { el.id = 'gImg'; cur.replaceWith(el); }
  }
  function show(btn) {
    tb.forEach(b => b.classList.toggle('on', b === btn));
    let el;
    if (btn.dataset.video) {
      el = document.createElement('video');
      Object.assign(el, { src: btn.dataset.video, autoplay: true, muted: true, loop: true, playsInline: true });
    } else { el = document.createElement('img'); el.src = btn.dataset.src; el.alt = ''; }
    showMedia(el);
  }
  function showImage(src, alt) {
    if (!src) return;
    const im = document.createElement('img'); im.src = src; im.alt = alt || '';
    showMedia(im); tb.forEach(b => b.classList.remove('on'));
  }
  tb.forEach(b => b.onclick = () => show(b));
  const step = d => {
    if (!tb.length) return;
    const i = Math.max(0, tb.findIndex(b => b.classList.contains('on')));
    const b = tb[(i + d + tb.length) % tb.length];
    show(b); b.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
  };
  $$('.vib .g-arrow').forEach(a => a.onclick = () => step(a.classList.contains('next') ? 1 : -1));
  if (tb.length < 2) $$('.vib .g-arrow').forEach(a => a.hidden = true);
  const dots = $('#dots');
  if (dots && tb.length) {
    tb.forEach(() => dots.appendChild(document.createElement('i')));
    const idx = () => Math.max(0, tb.findIndex(b => b.classList.contains('on')));
    const paint = () => [...dots.children].forEach((d, i) => d.classList.toggle('on', i === idx()));
    new MutationObserver(paint).observe($('#thumbs'), { subtree: true, attributes: true, attributeFilter: ['class'] });
    paint();
    let x0 = null;
    main.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', e => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) show(tb[(idx() + (dx < 0 ? 1 : -1) + tb.length) % tb.length]);
    });
  }

  // ---------- variants ----------
  const VARS = JSON.parse(($('#vibVariants') || {}).textContent || '[]');
  const fb = CFG.fallback || {};
  const DESIGNS = CFG.singleVariant || !VARS.length
    ? Object.entries(fb).map(([n, img]) => [n, img, CFG.firstVariant])
    : VARS.map(v => [v.title, (v.featured_image && v.featured_image.src) || fb[v.title] || fb['Green Tree'], v.id, v.available]);
  const find = n => DESIGNS.find(d => d[0] === n) || DESIGNS[0];

  // plain variant picker block (used when the built-in bundles block is removed, e.g. with Kaching)
  const vSel = $('#vibVariantSelect');
  if (vSel) vSel.onchange = () => {
    const v = VARS.find(x => String(x.id) === vSel.value); if (!v) return;
    if (idInput) idInput.value = v.id;
    set('#price', fmt(v.price / 100)); set('#atcPrice', fmt(v.price / 100)); set('#atcPrice2', fmt(v.price / 100));
    if (v.featured_image) showImage(v.featured_image.src, v.title);
    idInput && idInput.dispatchEvent(new Event('change', { bubbles: true }));
  };

  // ---------- Kaching (or any app) design dropdowns → show that variant's image ----------
  const fileOf = u => (u || '').split('?')[0].split('/').pop().replace(/_\d+x\d*(?=\.)/, '');
  function showVariant(v) {
    const src = v && v.featured_image && v.featured_image.src;
    if (!src) return;
    const f = fileOf(src).replace(/\.[a-z]+$/i, '');
    const thumb = tb.find(b => (b.dataset.src || '').includes(f));
    if (thumb) { show(thumb); thumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); }
    else showImage(src.startsWith('//') ? 'https:' + src : src, v.title);
  }
  document.addEventListener('change', e => {
    const sel = e.target.closest && e.target.closest('kaching-bundle select, .vib-app select');
    if (!sel) return;
    const val = sel.value;
    const v = VARS.find(x => String(x.id) === val || x.title === val || x.option1 === val || x.option2 === val || x.option3 === val);
    showVariant(v);
  });

  // ---------- built-in bundles block ----------
  const bundlesEl = $('#bundles');
  const picks = [DESIGNS[0][0], DESIGNS[0][0], DESIGNS[0][0]];
  let bundle = null;
  function renderRows(b) {
    const q = +b.dataset.qty, box = b.querySelector('.b-designs');
    if (!box || DESIGNS.length < 2) { if (box) box.innerHTML = ''; return; }
    box.innerHTML = '<span class="b-dl">Design</span>' + Array.from({ length: q }, (_, i) => `
      <span class="b-row"><img src="${find(picks[i])[1]}" alt="">${q > 1 ? `<span class="n">Bottle ${i + 1}</span>` : ''}
        <select data-i="${i}" aria-label="Design for bottle ${i + 1}">
          ${DESIGNS.map(([n, , , av]) => `<option${n === picks[i] ? ' selected' : ''}${av === false ? ' disabled' : ''}>${n}</option>`).join('')}
        </select></span>`).join('');
    box.querySelectorAll('select').forEach(sel => {
      sel.onclick = e => e.stopPropagation();
      sel.onchange = () => { picks[+sel.dataset.i] = sel.value; sel.parentElement.querySelector('img').src = find(sel.value)[1]; showImage(find(sel.value)[1], sel.value); sync(); };
    });
  }
  function pickBundle(b) {
    if (!b) return;
    $$('#bundles .bundle').forEach(x => { x.classList.toggle('on', x === b); x.setAttribute('aria-checked', x === b); });
    renderRows(b);
    const p = +b.dataset.price, c = +b.dataset.compare, q = +b.dataset.qty, sv = c - p;
    bundle = b;
    set('#price', fmt(p)); set('#compare', fmt(c)); set('#save', 'Save ' + fmt(sv));
    ['#compare', '#save'].forEach(s => { const e = $(s); if (e) e.hidden = sv <= 0.01; });
    set('#atcPrice', fmt(p)); set('#atcPrice2', fmt(p));
    const lbl = q === 1 ? 'Add to cart' : `Add ${q} ${b.dataset.label.replace(/^\d+\s*/, '')}`;
    set('#atcLabel', lbl); set('#atcLabel2', lbl);
    if (b.dataset.gift) set('#giftLine', b.dataset.gift);
    const fs = CFG.freeShip || 40;
    set('#shipSub', p >= fs ? 'Free shipping' : 'Free over $' + fs);
    sync();
  }
  function sync() {
    if (!bundle) return;
    const q = +bundle.dataset.qty;
    set('#stickySub', bundle.dataset.label + (DESIGNS.length > 1 ? ' · ' + picks.slice(0, q).join(', ') : ''));
    const si = $('#stickyImg'); if (si) si.src = find(picks[0])[1];
  }
  if (bundlesEl) {
    $$('#bundles .bundle').forEach(b => {
      b.onclick = () => { if (!b.classList.contains('on')) pickBundle(b); };
      b.onkeydown = e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pickBundle(b); } };
    });
    pickBundle($('#bundles .bundle.on') || $('#bundles .bundle'));
  }
  window.vibPickBundle = n => { const b = $$('#bundles .bundle')[n]; if (b) pickBundle(b); };

  // ---------- add to cart ----------
  async function addBundle(btn) {
    const q = +bundle.dataset.qty, counts = {};
    picks.slice(0, q).forEach(n => { const id = find(n)[2]; counts[id] = (counts[id] || 0) + 1; });
    const items = Object.entries(counts).map(([id, quantity]) => ({ id: +id, quantity }));
    if (btn) btn.disabled = true;
    try {
      const r = await fetch(CFG.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!r.ok) throw new Error((await r.json()).description || 'Could not add to cart');
      location.href = CFG.cartUrl;
    } catch (e) { toast(e.message); if (btn) btn.disabled = false; }
  }
  // with the built-in bundles block we add the chosen bottles ourselves;
  // without it the form submits normally, so apps like Kaching can take over
  if (form && bundlesEl) form.addEventListener('submit', e => { e.preventDefault(); addBundle($('#atc')); });
  const atc2 = $('#atc2');
  if (atc2) atc2.onclick = () => {
    if (bundlesEl) return addBundle(atc2);
    if (form) { form.requestSubmit ? form.requestSubmit($('#atc') || undefined) : form.submit(); }
  };

  // ---------- sticky bar ----------
  const atc = $('#atc'), sticky = $('#sticky');
  if (atc && sticky) {
    const mobile = matchMedia('(max-width:900px)');
    new IntersectionObserver(([e]) => sticky.classList.toggle('show', !e.isIntersecting && (mobile.matches || e.boundingClientRect.top < 0))).observe(atc);
  }

  // ---------- trust row: delivery window + ship day ----------
  (function () {
    const addBiz = (d, n) => { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; };
    const ship = addBiz(new Date(), 1), a = addBiz(ship, 5), b = addBiz(ship, 8);
    const tmr = new Date(); tmr.setDate(tmr.getDate() + 1);
    const sd = $('#shipDay');
    if (sd && /tomorrow/i.test(sd.textContent) && ship.toDateString() !== tmr.toDateString())
      sd.textContent = 'Ships ' + ship.toLocaleDateString('en-US', { weekday: 'long' });
    const f = d => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    set('#eta', a.getMonth() === b.getMonth() ? f(a) + '–' + b.getDate() : f(a) + '–' + f(b));
  })();

  // ---------- urgency block ----------
  const xb = $('.vib .xbar');
  if (xb) {
    const left = parseInt(xb.dataset.stock, 10), below = parseInt(xb.dataset.stockBelow, 10) || 50;
    if (!isNaN(left) && left > 0 && left <= below) { set('#stockLeft', left); $('#stockLine').hidden = false; }
    if (xb.dataset.xmas === 'true') {
      const n = new Date(), y = n.getFullYear(), cut = new Date(y, 11, 15, 23, 59), el = $('#xmasLine');
      const days = Math.ceil((cut - n) / 864e5);
      let t = '';
      if (n >= new Date(y, 10, 20) && days > 14) t = '🎄 Order by Dec 15 for Christmas delivery';
      else if (days > 1 && days <= 14) t = `🎄 <b>${days} days left</b> to order for Christmas`;
      else if (days === 1 || days === 0) t = '🎄 <b>Last chance</b> for Christmas delivery';
      else if (n.getMonth() === 11 && n.getDate() > 15 && n.getDate() < 25) t = '🎄 Orders now arrive just after Christmas';
      if (t && el) { el.innerHTML = t; el.hidden = false; }
    }
  }
})();
